import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Plus } from "lucide-react"
import { useNavigate } from "react-router"
import { ModuleHeader } from "../../shared/ModuleHeader"
import { ConformityInboxView } from "./ConformityInboxView"

/** Customer Studio → Conformity landing.
 *
 *  Thin wrapper around ConformityInboxView. Mirrors CustomerRequestsModule's
 *  shape (ModuleHeader + right-side action + list-view body) so the two
 *  Customer Studio tabs feel identical. The "+ Generate declarations" button
 *  routes to the wizard, which used to be *this* URL — moved to /new so the
 *  landing page can host the inbox by default. */
export function ConformityInboxModule() {
  const { translate } = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      data-agent-target="conformity.inbox"
      className="flex min-h-full flex-col gap-6 p-6"
    >
      <ModuleHeader
        title={translate("MC_CONFORMITY_TITLE")}
        subtitle={translate("MC_CONFORMITY_SUBTITLE")}
        helpArticle={{
          categoryId: "customer-studio",
          articleId: "customer.conformity",
        }}
        right={
          <Button
            size="sm"
            className="bg-yellow1 text-black hover:bg-yellow2"
            onClick={() =>
              navigate("/material-compliance/customer-studio/conformity/new")
            }
          >
            <Plus size={14} className="mr-1.5" />
            {translate("MC_CONFORMITY_BTN_GENERATE")}
          </Button>
        }
      />

      <ConformityInboxView />
    </div>
  )
}
